/**
 * redirect to "Portal home page", for use when we fail to parse Portal's
 * consent cookie
 *
 * this should only be called inside an `isPortal()` condition
 */
export const redirectToPortalHome = (window: Window) => {
  window.location.assign(window.location.origin);
};

/**
 * redirect to a Portal product url, for use when we click on a Portal
 * connection in PortalConnectionButton
 *
 * this should only be called inside an `isPortal()` condition
 */
export const redirectToPortalProduct = (
  window: Window,
  /** comes from portal-sdk Connection */
  dashboardUrl: string,
  /** a string like "designer" | "explorer" | "studio" */
  product: string
) => {
  window.location.assign(`${dashboardUrl}${product}/`);
};
